import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiButtonCss = ":host{background-color:white;border-radius:8px;cursor:pointer;padding:16px}:host([disabled]){cursor:default}";

const Button = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Button.style = ttuiButtonCss;

export { Button as ttui_button };

//# sourceMappingURL=ttui-button.entry.js.map